var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube-loading"},[_c('span',{staticClass:"cube-loading-spinners",style:(_vm.style)},_vm._l((_vm.balde),function(item){return _c('i',{staticClass:"cube-loading-spinner"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }